import { evaluateSubmissionRules } from './client-rule-evaluator'
import { firstSubmissionRedirect } from '../../../shared/submission-redirect'
import { pushAppPath } from './push-app-path'
import { writeLoggedInUser } from './live-user-storage'

async function completeSignIn ({
  username,
  userSession,
  submissionRules,
  fieldValues,
  modalRoute,
  account,
  application,
  path,
  accessKey,
  embed,
  router
}) {

  writeLoggedInUser(username, { account, application })

  const actions = evaluateSubmissionRules(submissionRules, fieldValues, {
    openInModal: !!(modalRoute && modalRoute.active)
  })

  for (const action of actions || []) {

    if (action.type !== 'close_modal' && action.type !== 'close_modal_reload') continue

    window.dispatchEvent(new CustomEvent('superturbo-close-modal', {
      detail: { reload: action.type === 'close_modal_reload' }
    }))
  }

  const redirectPath = firstSubmissionRedirect(actions, {
    application,
    path,
    accessKey,
    embed
  })

  if (redirectPath) await pushAppPath(router, redirectPath)

  window.dispatchEvent(new CustomEvent('superturbo-login', {
    detail: { username, userSession }
  }))

  return redirectPath
}

export { completeSignIn }
